import React from "react";
import { useNavigate } from "react-router-dom";
import formatMoney from "../components/formatMoney";
import "../styles/ordersCards.css";

const OrdersCards = ({ orders, onPayNowClick }) => {
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const handleOrderClick = (orderId) => {
    navigate(`/orders/${orderId}`);
  };

  return (
    <div className="orders-cards-container">
      {orders.map((order) => (
        <div
          key={order.order_id}
          className="order-card"
          onClick={() => handleOrderClick(order.order_id)}
        >
          <div className="order-card-cell" data-label="Order ID">
            {order.order_id.substring(0, 8)}...
          </div>
          <div className="order-card-cell" data-label="Date">
            <span className="orderdate">{formatDate(order.created_at)}</span>
          </div>
          <div className="order-card-cell" data-label="Status">
            <span className="order-status">{order.status}</span>
          </div>
          <div className="order-card-cell" data-label="Total">
            <div className="order-price-details">
              {order.final_total && order.final_total !== order.total_price ? (
                <div className="price-with-discount">
                  <span className="original-price">
                    {formatMoney(order.total_price)}
                  </span>
                  <span className="final-price">
                    {formatMoney(order.final_total)}
                  </span>
                </div>
              ) : (
                <span>{formatMoney(order.total_price)}</span>
              )}
            </div>
          </div>
          <div className="order-card-cell" data-label="Payment">
            <span
              className={`order-payment-status ${
                order.payment_status === "Paid" ? "paid" : ""
              }`}
            >
              {order.payment_status}
            </span>
          </div>
          <div className="order-card-cell" data-label="Products">
            {order.total_products}
          </div>
          <div className="order-card-action">
            <button
              className={`order-card-button ${
                order.payment_status === "Paid" ? "paid" : ""
              }`}
              onClick={(event) => onPayNowClick(order, event)}
            >
              {order.payment_status === "Paid" ? "View Details" : "Pay Now"}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OrdersCards;
